export enum PageScreenPosition {
    Main = "main",
    Modal = "modal",
}

export enum WireModalSize {
    Small = "small",
    Large = "large",
}

export interface ParsedScreenBase {
    readonly screenName: string;
    readonly rowID: string | undefined;
}

export interface ParsedMainScreen extends ParsedScreenBase {
    readonly kind: PageScreenPosition.Main;
}

export interface ParsedModalScreen extends ParsedScreenBase {
    readonly kind: PageScreenPosition.Modal;
    readonly size: WireModalSize;
}

export type ParsedScreen = ParsedMainScreen | ParsedModalScreen;

export interface ParsedPath {
    readonly tabScreenName: string;
    readonly rootScreen: ParsedMainScreen;
    readonly screenStack: readonly ParsedScreen[];
}
